/*jslint browser: true, vars: true, plusplus: true, devel: true, nomen: true, indent: 4, maxerr: 50 */
/*global $, google, define, require, window */
(function () {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Backbone = require('backbone'),
        AngularOEPage = require('../../ts/main.ts'),

        template = require('home/templates/AngularHome.html'),
        templateFn = _.template(template);

    window.App = Backbone.View.extend({

        render: function () {
            var me = this;
            this.$el.html(templateFn({
                i18n: i18n
            }));

            AngularOEPage.init();

            return this;
        }

    });
})();



//////////////////
// WEBPACK FOOTER
// ./js/home/AngularApp.js
// module id = 695
// module chunks = 23